import ButtonRegister from './ButtonRegister';
export default ButtonRegister;
